import { render, staticRenderFns } from "./CouponDetails.vue?vue&type=template&id=0e6478e3"
import script from "./CouponDetails.vue?vue&type=script&lang=js"
export * from "./CouponDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports